import React from 'react';
import './InputText.scss';

const InputText = ({
  placeholder,
  cls,
  onChange,
  value,
  type= 'text'
}) => {
  return (
    <input 
      className={`industry-expert-input ${cls}`}
      placeholder={placeholder}
      onChange={onChange}
      value={value}
      type={type}
    />
  )
}

export default InputText;